import domReady from '@roots/sage/client/dom-ready';
import 'bootstrap';
import 'video.js/dist/video.min';
// import './util/turn.min';
// import './util/zoom.min';
import '@lottiefiles/lottie-player';
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';
import { faCircleArrowUp, faArrowRight, faLongArrowAltLeft, faLongArrowAltRight, faTimes, faMoon, faSun, faBars, faPhone, faMapMarkerAlt, faAngleLeft, faAngleRight, faCircle, faSearch, faHome, faExclamationTriangle, faTag, faAddressCard, faSignInAlt, faUser, faBlog, faCog } from '@fortawesome/free-solid-svg-icons';
import { faClock, faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faTwitter, faInstagram, faLinkedinIn, faFacebookF, faYoutube } from '@fortawesome/free-brands-svg-icons';
config.searchPseudoElements = true;
import '../styles/app.scss';

/**
 * Application entrypoint
 */
domReady(async () => {

  // Enable FontAwesome
  config.searchPseudoElements = true;
  // add the imported icons to the library
  library.add(faCircleArrowUp, faArrowRight, faLongArrowAltLeft, faLongArrowAltRight, faSun, faTimes, faMoon, faUser, faBars, faCalendar, faPhone, faMapMarkerAlt, faAngleLeft, faAngleRight, faCircle, faSearch, faHome, faExclamationTriangle, faTag, faCog, faBlog, faSignInAlt, faAddressCard, faClock, faTwitter, faInstagram, faLinkedinIn, faFacebookF, faYoutube);

  // tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
  dom.watch();

  const searchState = {
    expanded: false,
    query: '', 
  };

  const initialInput = document.querySelector('.search-header');
  if (initialInput) {
    searchState.query = initialInput.value.trim();
    if (searchState.query.length > 0) {
      searchState.expanded = true;
    }
  }

  function initializeSearchBars() {
    document.querySelectorAll('.search-bar-container').forEach((searchBar, index) => {
      if (searchBar.dataset.initialized === 'true') return;

      const input = searchBar.querySelector('.search-header');
      const submitBtn = searchBar.querySelector('.search-submit-button');
      const icon = searchBar.querySelector('.icon-search');
      const form = searchBar.querySelector('.search-form');

      if (!input || !submitBtn || !icon || !form) {
        console.warn(`❌ Missing element(s) in search bar #${index}, skipping.`);
        return;
      }

      const fbcLogoAnchor = document.getElementById('fbc-logo-anchor-header-normal');
      const fbcLogoAnchorOffcanvas = document.getElementById('fbc-logo-anchor-header-offcanvas');

      // Sync input field value from shared state
      input.value = searchState.query;
      submitBtn.style.display = input.classList.contains('search_expanded') && input.value.trim().length > 0
                                ? 'block'
                                : 'none';
      
      // Sync expansion state
      if (searchState.expanded) {
        input.classList.add('search_expanded');
      }

      icon.addEventListener('click', () => {
        searchState.expanded = !searchState.expanded;

        // Toggle all search bars + logos to match global expanded state
        document.querySelectorAll('.search-header').forEach(el => {
          if (el !== input) {
            el.classList.toggle('search_expanded', searchState.expanded);

            el.readOnly = !el.classList.contains('search_expanded');
            el.tabIndex = el.classList.contains('search_expanded') ? 0 : -1;
            
            const btn = el.closest('.search-bar-container')?.querySelector('.search-submit-button');
            if (btn) {
              btn.style.display = el.classList.contains('search_expanded') && el.value.trim().length > 0
                                  ? 'block'
                                  : 'none';
            }
          }
        });

        input.classList.toggle('search_expanded');
        
        fbcLogoAnchor?.classList.toggle('search_expanded', searchState.expanded);
        fbcLogoAnchorOffcanvas?.classList.toggle('search_expanded', searchState.expanded);

        input.readOnly = !input.classList.contains('search_expanded');
        input.tabIndex = input.classList.contains('search_expanded') ? 0 : -1;

        submitBtn.style.display = input.classList.contains('search_expanded') && input.value.trim().length > 0
                                  ? 'block'
                                  : 'none';
      });

      input.addEventListener('input', () => {
        // Update global query state
        searchState.query = input.value;

        // Sync all other inputs to reflect global query
        document.querySelectorAll('.search-header').forEach(el => {
          if (el !== input) el.value = searchState.query;
        });

        document.querySelectorAll('.search-submit-button').forEach(btn => {
          btn.style.display = searchState.query.trim().length > 0 ? 'block' : 'none';
        });
      });

      // Mark this one as initialized
      searchBar.dataset.initialized = 'true';
    });
  }

  initializeSearchBars();

  const offcanvasButton = document.querySelector('.icon-nav-offcanvas');
  if (offcanvasButton) {
    offcanvasButton.addEventListener('click', () => {
      setTimeout(() => {
        initializeSearchBars();
      }, 5);
    });
  }

document.querySelectorAll('.image-card-overlay.with-modal').forEach(function(element) {
  element.addEventListener('click', function(event) {
    if (event.target.tagName === 'A' && event.target.href !== undefined) {
      // If the element clicked is a link inside '.image-card-overlay.with-modal' div
      // then do NOT open popup, do a link redirection to its href
      event.stopPropagation(); // Allows other handlers on the event.target to be executed.
    } else {
      let anchor = element.id;
      window.location.hash = anchor;
      showImageCardModal(element);
      event.preventDefault();
      return false;
    }
  });
});

}); // end of domReady

function showImageCardModal(targetElement) {
  // Find the sibling with class 'image-grid-expand'
  const expandImageGroup = targetElement.parentNode.querySelector('.image-grid-expand');
  const expandImageGroupClose = expandImageGroup.querySelector('.image-grid-expand-close');

  expandImageGroup.style.display = "block";

  // Handler to close modal
  function closeModal() {
    expandImageGroup.style.display = "none";
    const currentURL = window.location.href;
    if (window.location.hash) {
      window.history.pushState("", document.title, currentURL.split('#')[0]);
    }
    // Remove event listeners after closing
    window.removeEventListener('click', onWindowClick);
    window.removeEventListener('keydown', onWindowKeydown);
  }

  function onWindowClick(event) {
    if (event.target === expandImageGroup || event.target === expandImageGroupClose) {
      closeModal();
    }
  }

  function onWindowKeydown(event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      closeModal();
    }
  }

  window.addEventListener('click', onWindowClick);
  window.addEventListener('keydown', onWindowKeydown);
}